import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AuthUsersGuard} from '../resources/guards/authUsers.guard';
import {AllUsersGuard} from '../resources/guards/allUsers.guard';
import {UiKitComponent} from './static/ui-kit/ui-kit.component';
import {UiTablesComponent} from "./static/ui-tables/ui-tables.component";

const routes: Routes = [
  {
    path: '',
    data: {
      hidden: true,
    },
    redirectTo: 'stores',
    pathMatch: 'full'
  },
  {
    path: 'ui-kit',
    component: UiKitComponent,
    data: {
      hidden: true,
      title: 'UI kit',
      breadcrumbs: 'UI-Kit'
    },
    canActivate: [AuthUsersGuard]
  },
  {
    path: 'ui-tables',
    component: UiTablesComponent,
    data: {
      hidden: true,
      title: 'UI tables',
      breadcrumbs: 'UI-Tables'
    },
    canActivate: [AuthUsersGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: []
})
export class PagesRoutesModule { }

